<template>
  <div :id="`room-${room}`" class="RoomBlock centerContent" :class="`${$screen.device}`" :style="{maxWidth:$ui.size.contentMaxWidth+'px'}">
    <div class="media">
      <div class="backpad" v-if="$screen.device!=='mobile'"></div>

      <div v-if="mainImage!==undefined" class="image" @click="$refs[`roomGallery-${room}`].start()" :style="{ backgroundImage: `url(${mainImage})`}">
        <div class="badges" >
          <div v-if="roomData.alias ==='familyLux'" class="badge new">Новые номера</div>
          <div v-if="roomData.alias ==='familyLux'" class="badge promo">Промо скидка 20%</div>
        </div>
        <room-over-price v-if="showRoomsTag" :price="$store.state.minPrice[room]" :style="{bottom:'100px'}"/>
        <div class="bage floor"><img :src="require(`@/assets/icons/floor.png`)"><span class="label">ПОЛ: {{roomData.floor}}</span></div>
        <div class="bage size"><img :src="require(`@/assets/icons/size.png`)"><span class="label">{{roomData.size}} КВ.М</span></div>
      </div>
    </div>
    <div class="content">
      <div class="room_description">
        <div class="header">
          <div class="title">
            <div class="icon"><img :src="require(`@/assets/icons/key-room.png`)"></div>
            <span class="room">НОМЕР</span>
            <span class="name">«{{roomData.name}}»</span>
            <div class="separator"></div>
          </div>
          <div class="options">
            <div class="bage rooms"><img :src="require(`@/assets/icons/door.png`)"><span class="label">{{roomData.rooms}}</span></div>
            <div class="bage capacity"><img :src="require(`@/assets/icons/persons.png`)"><span class="label">{{roomData.guests}}</span></div>

          </div>
        </div>
        <p class="text">{{roomData.description}}</p>

        <div class="separator"></div>
        <div class="room_images">
          <image-gallery v-if="gallery!==undefined" :images="$state.galleries.rooms[room]" :ref="`roomGallery-${room}`" :gallery-i-d="`gallery-${room}`"/>
        </div>
        <div class="facilities">
          <div class="facility" v-for="(facility,facilityIndex) in roomData.facilities" :key="facilityIndex">
            <hotel-icon :icon="$state.facilities[facility].icon"/>
            <p class="name">{{$state.facilities[facility].name}}</p>
          </div>
        </div>
      </div>
      <div class="actions" :class="`${$screen.device}`" :style="{maxWidth: $screen.width+'px'}">
        <v-btn @click="showRoomPrice(room)"  :block="true" variant="contained-flat" :border="false"
               :style="{fontSize:$screen.width<375?'9px':'12px'} " height="40" size="small" color="primary">
          <span  style="color: white">ЦЕНЫ В ЭТОМ НОМЕРЕ</span>
        </v-btn>
        <v-btn @click="bookRoom(room)"  :style="{fontSize:$screen.width<375?'9px':'12px'} " :block="true" variant="contained-flat" :border="false" height="40"  size="small" color="green">
          <p style="color: white">ЗАБРОНИРОВАТЬ</p>
        </v-btn>
      </div>

    </div>

  </div>
</template>

<script>


import ImageGallery from "@/components/ImageGallery";
import HotelIcon from "@/hotel/HotelIcon";
import RoomOverPrice from "@/hotel/RoomOverPrice";

export default {
  name: 'RoomBlock',
  components: {RoomOverPrice, HotelIcon, ImageGallery},
  props:['room'],
  methods:{
    bookRoom(room){
      this.$commit('updateBookingRoom',room)
      this.$commit('openModal','ModalBooking')
    },
    showRoomPrice(room){
      this.$commit('updateBookingRoom',room)
      this.$commit('openModal','ModalRoomPrice')
    }
  },
  data: () => ({
    gallery: undefined,
    mainImage:undefined,
    roomData:'',
    showRoomsTag:false,

  }),
  mounted() {
    this.$nextTick(async ()=>{
      this.roomData = this.$store.state.rooms[this.room]
      this.gallery = this.$state.galleries.rooms[this.room]
      this.mainImage = this.$state.galleries.rooms[this.room][0].largeURL
    })

  }
}
</script>


<style scoped>

.badges{position: absolute; top: 10px; right: 0; display: grid; grid-auto-flow: column; column-gap: 4px}
.badge{padding: 5px; border-radius: 20px; font-size: 12px;}
.badge.new{background-color: red; color: white; }
.badge.promo{background-color: #14cc17; color: white; }

  .RoomBlock{display: grid;grid-template-columns: 1fr 2fr; margin-bottom: 10px}
  .RoomBlock>.media{display: grid;position: relative;align-items: center;padding-right: 2px; min-height: 300px}
  .RoomBlock>.media>.backpad{background-color: #e3e1e1;width: 100%;height: 100%;}
  .RoomBlock>.media>.image{cursor: zoom-in; position: absolute;left: 0;  background-color: #959595;height: 90%;width: 105%; min-width: 200px; background-size: cover;background-position: center}
  .RoomBlock>.media>.image{display: flex;flex-wrap: wrap; column-gap: 4px; padding-bottom: 10px; align-content: flex-end; justify-content: flex-end; row-gap: 3px;}
  .RoomBlock>.media>.image>.bage{display: grid; padding: 4px; color: black; font-size: 11px; font-weight: normal; text-transform: uppercase; grid-template-columns: auto 1fr; column-gap: 4px; align-items: center; background-color: white; border-radius: 10px;}
  .RoomBlock>.media>.image>.bage>.label{padding-top: 3px}
  .RoomBlock>.media>.image>.bage>img{height: 14px}
  .RoomBlock.mobile>.media>.image>.bage>.label{padding-top: 0px}

  .RoomBlock>.media>.image>.bage.size{margin-right: 10px}


  .RoomBlock>.content{display: grid;padding: 5% 8%; padding-right: 6%;  background-color: #fcf8f6; grid-template-rows: 1fr auto}

  .RoomBlock>.content>.room_description{display: grid; align-content: flex-start;}
  .RoomBlock.desktop>.content>.room_description>.header{display: grid; align-content: flex-start; grid-template-columns: 1fr auto}

  .RoomBlock>.content>.room_description>.header>.title{font-size: 24px; display: grid; grid-template-columns: auto auto auto 1fr auto; justify-content: flex-start; align-items: center; column-gap: 6px}
  .RoomBlock>.content>.room_description>.header>.title>.room{font-weight: lighter}
  .RoomBlock>.content>.room_description>.header>.title>.name{font-weight: bold; text-transform: uppercase }
  .RoomBlock>.content>.room_description>.header>.title>.size{font-size: 10px; display: flex; column-gap: 4px; align-items: center; font-weight: bold; text-transform: uppercase }
  .RoomBlock>.content>.room_description>.header>.title>.icon{height: 100%;display: grid; align-items: center; border-radius: 50%;overflow: hidden}
  .RoomBlock>.content>.room_description>.header>.title>.icon>img{height: 20px;border-radius: 20px;}


  .RoomBlock>.content>.room_description>.header>.options{display: grid; grid-auto-flow: column; justify-content: flex-start; column-gap: 4px}
  .RoomBlock>.content>.room_description>.header{display: grid; align-content: center; align-items: center;}
  .RoomBlock>.content>.room_description>.text{font-size: 12px; text-transform: uppercase; padding-top: 10px; line-height: 15px}

  .RoomBlock>.content>.room_description>.header>.options>.bage{display:grid; padding: 4px; color: black; padding-right: 8px; background-color: #f2e9e1; height: 24px;padding-top: 3px; font-size: 11px; line-height: 11px; font-weight: normal; text-transform: uppercase; grid-template-columns: auto 1fr; column-gap: 4px; align-items: center;border-radius: 10px;}
  .RoomBlock>.content>.room_description>.header>.options>.bage>.label{padding-top: 3px}
  .RoomBlock>.content>.room_description>.header>.options>.bage>img{height: 14px}
  .RoomBlock>.content>.room_description>.header>.options>.bage>.label{padding-top: 0px}

  .RoomBlock.mobile>.content>.room_description>.header>.options>.bage{font-size: 10px}


  .RoomBlock>.content>.room_description>.separator{width: 100%; height: 2px; background-color: #dedada; margin: 10px 0px}
  .RoomBlock>.content>.actions{
    padding-top: 14px;
    display: grid;
    grid-template-columns: 1fr auto; column-gap: 4px; row-gap: 4px;
  }

  .RoomBlock>.content>.room_description>.room_images{min-height: 100px; height: 100%; padding-bottom: 10px}

  .RoomBlock.mobile>.content>.actions{padding: 5%; padding-bottom: 5px; padding-top: 10px;  grid-template-columns: 1fr}
  .RoomBlock>.content>.room_description>.facilities{display: flex;  flex-direction:row; column-gap: 4px; row-gap: 5px; flex-wrap: wrap}
  .RoomBlock>.content>.room_description>.facilities>.facility{ border-radius: 20px; padding: 2px; border: 1px dashed #bd9f7a; display: grid;grid-template-columns: auto 1fr; align-items: center; column-gap: 6px}
  .RoomBlock>.content>.room_description>.facilities>.facility>.name{font-size: 12px; padding-top: 2px; padding-right: 4px}
  .RoomBlock.mobile{grid-template-columns: 1fr}

  .RoomBlock.mobile>.content>.room_description>.facilities>.facility{}
  .RoomBlock.mobile>.content>.room_description>.facilities>.facility>.name{font-size: 10px}

  .RoomBlock.mobile>.content{padding: 0px}
  .RoomBlock.mobile>.content>.room_description{padding: 4%; padding-top: 10px; padding-bottom: 0px}
  .RoomBlock.mobile>.content>.room_description>.text{font-size: 11px}
  .RoomBlock.mobile>.media{padding: 0; height: 500px}
  .RoomBlock.mobile>.media>.image{width: 100%; height: 100%; position: unset}

</style>